export default {
  namespaced: true,
  state: {
    configuration: {},
    registerLink: "",
  },
  getters: {
    configuration: (state) => state.configuration
  },
  mutations: {
    configuration: (state, payload) => (state.configuration = payload),
  },
  actions: {
    save({}, payload) {
      return this.$apiService.post("/save-global-configuration", payload);
    },
    saveRegistration({}, payload) {
      return this.$apiService.post("/save-registration-configuration", payload);
    },
    saveFiles({}, payload) {
      return this.$apiService.post("/save-global-configuration-files", payload);
    },
    deleteFile({}, payload) {
      return this.$apiService.post(
        "/delete-global-configuration-files",
        payload
      );
    },
    show({ commit }) {
      return this.$apiService
        .get(`/get-global-configuration`)
        .then((response) => {
          commit("configuration", response?.data?.data ?? {});
          return response;
        });
    },
    createMillingHeadSize({}, payload) {
      return this.$apiService.post("/milling-head-size", payload);
    },
    updateMillingHeadSize({}, { id, data }) {
      return this.$apiService.put(`/milling-head-size/${id}`, data);
    },
    deleteMillingHeadSize({}, id) {
      return this.$apiService.delete(`/milling-head-size/${id}`);
    },
    getRegisterLink() {
      return this.$apiService
        .get(`/get-register-link`)
        .then((response) => {
          return response;
        });
    },
  },
};
